type GoogleConsentStatus = 'denied' | 'granted';

interface GoogleConsentState {
  ad_personalization: GoogleConsentStatus;
  ad_storage: GoogleConsentStatus;
  ad_user_data: GoogleConsentStatus;
  analytics_storage: GoogleConsentStatus;
}

export const getGoogleConsentState = (marketingCookies: boolean): GoogleConsentState => {
  const status = marketingCookies ? 'granted' : 'denied';

  return {
    ad_personalization: status,
    ad_storage: status,
    ad_user_data: status,
    analytics_storage: status,
  };
};

export const updateGoogleConsent = (marketingCookies: boolean) => {
  window.dataLayer = window.dataLayer || [];

  function gtag(..._command: unknown[]) {
    window.dataLayer.push(arguments);
  }

  gtag('consent', 'update', getGoogleConsentState(marketingCookies));
};
